export default __webpack_public_path__ + "static/media/solteirotriplo_1.31fc35db.jpg";